<template>
  <div v-if="superAdmin">
      <v-layout wrap row justify-start  pa-4>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Update Or Delete Orders By Key
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Agent"
										solo
										hide-details
										disabled
                    :loading="loading"
										v-model="userName"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Delimiter"
										solo
										disabled
										hide-details
                    :loading="loading"
										v-model="delimiter"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="keys"
										v-model="pastedData"
										solo
									></v-textarea>
              	</v-flex>
								<v-flex xs12 class="text-xs-center">
									{{logger}}
								</v-flex>
								<v-flex xs12>
									<div v-for="k in pKeys" :key="k">{{k}}</div>
								</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="deleteByKey()" :loading="loading" color="error" dark>
                delete
              </v-btn>
							<v-btn @click="deleteNewByKey()" :loading="loading" color="error" dark>
                delete from new data
              </v-btn>
            </v-card-actions>
						<v-card-actions>
              <v-spacer></v-spacer>
							<v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn>
							<v-btn @click="updateNewByKey()" :loading="loading" color="success" dark>
                update new data keys with values
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
				<v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Get Invoice Total
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Limit"
										solo
										hide-details
                    :loading="loading"
										v-model="limit"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Loops"
										solo
										hide-details
                    :loading="loading"
										v-model="loops"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Agent"
										solo
										hide-details
										disabled
                    :loading="loading"
										v-model="userName"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Delimiter"
										solo
										disabled
										hide-details
                    :loading="loading"
										v-model="delimiter"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="keys"
										v-model="pastedData"
										solo
									></v-textarea>
              	</v-flex>
								<v-flex xs12 class="text-xs-center">
									{{logger}}
								</v-flex>
								<v-flex xs12>
									<div v-for="k in pKeys" :key="k">{{k}}</div>
								</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<v-btn @click="loopGetOrdersTotalInv()" :loading="loading" color="success" dark>
                proccess invoice total for {{loops}} loops with {{limit}} leads each
              </v-btn>
            </v-card-actions>
						<v-card-actions>
              <v-spacer></v-spacer>
							<v-btn @click="invoiceTotalByKey()" :loading="loading" color="success" dark>
                proccess invoice total for keys
              </v-btn>
            </v-card-actions>
						<v-card-actions>
              <v-spacer></v-spacer>
							<v-btn @click="getAllFromStartOfYear()" :loading="loading" color="success" dark>
                proccess invoice total for all since 01-01-2021
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import countriesJSON from '@/countries-ash.json'
import axios from 'axios';
import { productApiUrl, crmApiUrl } from '@/config/urls';
const headers = {
  'Accept': 'application/json'
}
export default {
  data(){
    return {
			loading: false,
			pastedData:null,
			delimiter:',',
			logger:null,
			pKeys:[],
			countriesFullLoaded:countriesJSON,
			taxrates:null,
			last:null,
			limit:3,
			loops:2
    }
  },
  methods: {
		async getAllFromStartOfYear(){
			let all = await store.collection('leads').where('timestamp', '>', new Date('2021-02-14T00:00:00').getTime())
			.where('timestamp', '<=', new Date('2021-02-28T23:59:59').getTime())
			.get().then(x=>x.docs.map((y, i)=>{
				if(i==x.docs.length-1) this.last = y
				return {
					...y.data(), 
					key:y.id,
				}
			}))
			console.log(all);
			(async () =>{
				for (let i = 0; i < all.length; i++) {
					const order = all[i];
					if(order.key){
						let o = order
						let n = this.getBaseTotal(o);
						n = this.getTotal(n, n.key);
						n = this.getTotalAfterTax(n, n.key);
						console.log(n)
						if(typeof n === 'object') {
							await store.collection(`leads`).doc(order.key).update(n);
							this.pKeys.push(`${n.key} | total: ${n.total} | total_converted: ${n.total_converted} | total_after_tax: ${n.total_after_tax} | total_converted_after_tax: ${n.total_converted_after_tax} | total_invoice: ${n.total_invoice} | total_invoice_converted: ${n.total_invoice_converted}`)
						} else {
							this.pKeys.push(`${n.key} | Failed`)
						}
						if(i % 1000 == 0 ) {
							this.pKeys = []
						}
					}
				}
				this.pKeys.push('DOOOOOOOOOOONEEEEEEEEEE')
			})()
		},
		getBaseTotal(l){
      let total = 0
      let ftaxRate = this.taxrates.filter(x=> x.country == l.country)
      let taxRate = ftaxRate.length ? ftaxRate[0].rate : 0
      for (let i = 0; i < l.order.length; i++) {
        const item = l.order[i];
        total += parseFloat(item.baseprice) * parseFloat(item.quantity)
      }
      l.total_after_tax = (total + total * parseFloat(taxRate)).toFixed(2)
      l.total_amount = l.paid ? l.online_total : l.total_after_tax
      return l
    },
		async getTaxRates(){
       let a = await db.ref(`taxrates`).once('value').then(x=>x.val())
       this.taxrates = Object.values(a)
    },
		getTotal(l, key){
      if (!l.order || l.order.length == 0) return `0`
      
      let currRate = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      if(!currRate) return `0`
      let totalBase = 0 
      if(l.order && Array.isArray(l.order)) {
        l.order.forEach(order=>{
          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
        })
      }
      let total = totalBase * parseFloat(currRate.usd) 
      if (l.voucher) {
        total = total - (parseFloat(l.voucher.amount) * parseFloat(currRate.usd))
      }
      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
			l.total = totalBase.toFixed(2)
      l.total_converted = total.toFixed(2)
      l.currency = currRate.currencies ? currRate.currencies[0].code  : ''
      l.payment_cc = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].alpha2Code
      return l
    },
    getTotalAfterTax(l, key){
      if (!l.order || l.order.length == 0) return `0`
      
      let currRate = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      if(!currRate) return `0`
      let totalBase = 0 
      if(l.order && Array.isArray(l.order)) {
        l.order.forEach(order=>{
          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
        })
      }
      let total = totalBase * parseFloat(currRate.usd) 
      
      if (l.voucher) {
        total = total - (parseFloat(l.voucher.amount) * parseFloat(currRate.usd))
      }
      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
      
      l.total = totalBase.toFixed(2)
      
      let ftaxRate = this.taxrates.filter(x=> x.country == l.country)
      let taxRate = ftaxRate.length ? ftaxRate[0].rate : 0
      l.total_invoice = (totalBase + totalBase * parseFloat(taxRate)).toFixed(2)
      l.total_converted_after_tax = (total + total * parseFloat(taxRate)).toFixed(2)
      l.total_invoice_converted = ((totalBase + totalBase * parseFloat(taxRate)) * parseFloat(currRate.usd)).toFixed(2)

      if(l.manual_total){
        const cal_total = l.total_converted_after_tax
        let manual = parseFloat(l.manual_total)
        l.manual_discount = ((cal_total - manual) / cal_total) * 100
        l.total_invoice = (manual / parseFloat(currRate.usd)).toFixed(2)
        l.total_invoice_converted = manual
      } else {
        l.manual_discount = 0
      }
      l.tax = (total * parseFloat(taxRate)).toFixed(2)
      l.currency = currRate.currencies ? currRate.currencies[0].code  : ''
      l.payment_cc = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].alpha2Code
      let finalTotalwithTax = {
        total:`${l.manual_total ? l.manual_total : l.total_converted_after_tax} ${currRate.currencies ? currRate.currencies[0].code  : ''}`,
        tax:(total * parseFloat(taxRate)).toFixed(2)
      }
      return l
    },
		async GetOrdersAddTotalInvoice(){
			return new Promise(async (res, rej)=>{
				let orders
				if(this.last) {
					orders = await store.collection('leads')
					.orderBy('timestamp', 'desc')
					.startAfter(this.last)
					.limit(parseInt(this.limit)).get().then(x=>x.docs.map((y, i)=>{
						if(i==x.docs.length-1) this.last = y
						return {
							...y.data(), 
							key:y.id,
						}
					}))
				} else {
					orders = await store.collection('leads')
					.orderBy('timestamp', 'desc')
					.limit(parseInt(this.limit)).get().then(x=>x.docs.map((y, i)=>{
						if(i==x.docs.length-1) this.last = y
						return {
							...y.data(), 
							key:y.id,
						}
					}))
				}
				console.log(orders);
				(async x=>{
					for (let i = 0; i < orders.length; i++) {
						const o = orders[i];
						let n = this.getBaseTotal(o)
						n = this.getTotal(n, n.key)
						n = this.getTotalAfterTax(n, n.key)
						this.pKeys.push(`${n.key} | total: ${n.total} | total_converted: ${n.total_converted} | total_after_tax: ${n.total_after_tax} | total_converted_after_tax: ${n.total_converted_after_tax} | total_invoice: ${n.total_invoice} | total_invoice_converted: ${n.total_invoice_converted}`)
						console.log(n)
					}
					res()
				})()
			})
    },
		async loopGetOrdersTotalInv(){
			(async x=>{
				for (let i = 0; i < this.loops + 1; i++) {
					await this.GetOrdersAddTotalInvoice()
				}
			})()
		},
		async invoiceTotalByKey(){
			let a = this.getArray();
			(async () =>{
				for (let i = 0; i < a.length; i++) {
					const order = a[i];
					if(order.key){
						let o = await store.collection(`leads`).doc(order.key).get().then(x=>x.data());
						let n = this.getBaseTotal(o);
						n = this.getTotal(n, n.key);
						n = this.getTotalAfterTax(n, n.key);
						await store.collection(`leads`).doc(order.key).update(n);
						this.pKeys.push(`${n.key} | total: ${n.total} | total_converted: ${n.total_converted} | total_after_tax: ${n.total_after_tax} | total_converted_after_tax: ${n.total_converted_after_tax} | total_invoice: ${n.total_invoice} | total_invoice_converted: ${n.total_invoice_converted}`)
					}
					this.pKeys.push('DOOOOOOOOOOONEEEEEEEEEE')
				}
			})()
		},
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
			var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
		},
		deleteByKey(){
			this.pKeys=[]
			let a = this.getArray();
			(async () =>{
				for (let i = 0; i < a.length; i++) {
					const order = a[i];
					if(order.key){
						await db.ref(`leads`).update({
							[order.key]:null
						})
						this.logger = order.key
						console.log(order.key)
					}
				}
				this.logger = 'DONE'
			})()
		},
		deleteNewByKey(){
			this.pKeys=[]
			let a = this.getArray();
			(async () =>{
				for (let i = 0; i < a.length; i++) {
					const order = a[i];
					if(order.key){
						await store.collection(`leads`).doc(order.key).delete()
						try {
							await axios.get(productApiUrl(`leads-delete/${order.key}`), order, {headers}).then(x=>x.data)
							await axios.get(crmApiUrl(`deleteninja29983/${order.key}`)).then(x=>x.data).catch(async (error)=> console.log('NINJA ERROR ', error))
						} catch (error) {
							console.log('lead delete error', error)
						}
						this.logger = order.key
						console.log(order.key)
					}
				}
				this.logger = 'DONE'
			})()
		},
		updateByKey(){
			this.pKeys=[]
			let a = this.getArray();
			(async () => {
				for (let i = 0; i < a.length; i++) {
					const order = a[i];
					if(order.key){
						let n = order
						let k = order.key
						this.pKeys.push(order.key)
						delete n.key
						await db.ref(`leads/${k}`).update(n)
						console.log(order.key)
					}
				}
			})()
		},
    updateNewByKey() {
			this.pKeys=[]
			this.fKeys=[]
			let a = this.getArray();
			(async () => {
				for (let i = 0; i < a.length; i++) {
					const order = a[i];
					if(order.key){
						let n = order
						let k = order.key
						this.pKeys.push(order.key)
						try {
							await store.collection(`leads`).doc(k).update(n)
							try {
								let update_lead = await store.collection('leads').doc(k).get().then(x=>{return {...x.data(), key:k}})
								await axios.post(productApiUrl('leads'), update_lead, {headers}).then(x=>x.data)
								if(update_lead.ninja) {
									await axios.post(crmApiUrl(`crmleads/${update_lead.id}`), update_lead, {headers}).then(x=>x.data).catch(async (error)=> console.log('NINJA ERROR ', error))
								}
							} catch (error) {
								console.log('lead sync error', error)
							}
						} catch (error) {
							fKeys.push(p)
							console.log('lead sync error 2', error)
						}
						console.log(order.key)
					}
				}
				console.log('failed keys', this.fKeys)
			})()
		}
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){
		this.getTaxRates()
		// let a = await db.ref(`users`).once('value').then(x=>x.val())
		// let u = Object.values(a);
		// (async ()=>{
		// 	for (let i = 0; i < u.length; i++) {
		// 		const user = u[i];
		// 		await db.ref(`users/${user.user_id}`).update({access:true})
		// 		console.log(user)
		// 	}
		// 	let b = await db.ref(`users`).once('value').then(x=>x.val())
		// 	console.log(b)
		// })()
		// let a = await db.ref(`formbuilder`).once('value').then(x=>x.val())
		// let b = Object.values(a)
		// let c = b.filter(x=>x.fid == '5185307')
		// let e = b.filter(x=>{
		// 	for (const key in x) {
		// 		if (x.hasOwnProperty(key)) {
		// 			const val = x[key];
		// 			if(val.includes('568555066')) {
		// 				return x
		// 			}
		// 		}
		// 	}
		// })
		// console.log(b.length)
		// console.log(e);
		// (async ()=>{
		// 	let gg =0 
		// 	for (let i = 0; i < b.length; i++) {
		// 		const entry = b[i];
		// 		let entry_id = entry.entry_id + '-' + entry.fid
		// 		let m = await db.ref('leads').orderByChild(`entry_id`).equalTo(entry_id).once('value').then(x => x.val())
		// 		if(!m){
		// 			console.log(entry_id)
		// 			gg++
		// 		}
		// 	}
		// 	console.log(gg)
		// 	console.log(b.length)
		// })()

		
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
